import { SELECT_ALL, UNSELECT_ALL } from './CheckboxCounterContainer/constants'
import {
  ACTIVATE_SELECT_ALL,
  ASSIGN_REQUEST_ASYNC,
  ASSIGNED_FILTER_CHANGE,
  COMPANIES_DATA_REQUEST_ASYNC,
  DEFAULT_ASSIGNED_FILTER,
  FILTERS_CHANGE,
  FILTERS_CLEAR,
  FILTERS_SUBMIT,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SELECT_TOGGLE,
  SORT_PROPERTY_CHANGE,
} from './constants'

export default function () {
  const initialState = {
    data: {
      companies: [],
    },
    groupSettings: {},
    error: null,
    loader: false,
    tableLoader: false,
    page: 1,
    search: '',
    sortProperty: '', // first_name-desc
    selectedCompaniesMap: {},
    assignedToOtherMap: {},
    selectAll: false,
    filters: {
      emailIntegrationFilter: [],
      groupSettingsFilter: [],
      assignedFilter: DEFAULT_ASSIGNED_FILTER,
    },
    selectionHasChanged: false,
    assignedCompaniesSaved: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SELECT_TOGGLE: {
        if (state.selectedCompaniesMap[action.payload.id]) {
          delete state.selectedCompaniesMap[action.payload.id]
        } else {
          state.selectedCompaniesMap[action.payload.id] = true
        }
        return {
          ...state,
          selectedCompaniesMap: {
            ...state.selectedCompaniesMap,
          },
          selectAll: false,
          selectionHasChanged: true,
        }
      }
      case SELECT_ALL:
        return {
          ...state,
          selectionHasChanged: true,
          selectedCompaniesMap: state.data.companies
            .filter(
              (e) => !e?.groupSettingsName || e?.groupSettingsName === state.groupSettings?.name
            )
            .reduce((prev, curr) => ({ ...prev, [curr.id]: true }), {}),
        }
      case UNSELECT_ALL:
        return {
          ...state,
          selectedCompaniesMap: {},
          selectAll: false,
          selectionHasChanged: true,
        }
      case ACTIVATE_SELECT_ALL:
        return {
          ...state,
          selectAll: true,
          selectionHasChanged: true,
        }
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          tableLoader: true,
          page: 1,
        }
      case SORT_PROPERTY_CHANGE:
        return {
          ...state,
          sortProperty: action.payload.value,
          tableLoader: true,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page || 1,
          tableLoader: true,
        }
      case FILTERS_SUBMIT:
        return { ...state, tableLoader: true }
      case FILTERS_CHANGE:
        return {
          ...state,
          filters: {
            ...state.filters,
            [action.payload.filterType]: action.payload.value,
          },
        }
      case ASSIGNED_FILTER_CHANGE:
        return {
          ...state,
          tableLoader: true,
          filters: {
            ...state.filters,
            assignedFilter: action.payload.value,
          },
        }
      case FILTERS_CLEAR:
        return {
          ...state,
          filters: {
            ...state.filters,
            emailIntegrationFilter: [],
            groupSettingsFilter: [],
          },
        }
      case ASSIGN_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          tableLoader: true,
          error: null,
          assignedCompaniesSaved: false,
        }
      case COMPANIES_DATA_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
          groupSettings: {
            name: action.payload.name,
            id: action.payload.id,
          },
        }
      case COMPANIES_DATA_REQUEST_ASYNC.SUCCESS: {
        const assignedToOther = action.payload.data.companies
          .filter((e) => e?.groupSettingsName && e?.groupSettingsName !== state.groupSettings?.name)
          .reduce((prev, curr) => ({ ...prev, [curr.id]: true }), {})
        const selectedCompanies = action.payload.data.assignedCompanies.reduce(
          (prev, curr) => ({ ...prev, [curr]: true }),
          {}
        )
        return {
          ...state,
          data: action.payload.data,
          loader: false,
          tableLoader: false,
          assignedToOtherMap: {
            ...state.assignedToOtherMap,
            ...assignedToOther,
          },
          selectedCompaniesMap: {
            ...state.selectedCompaniesMap,
            ...selectedCompanies,
          },
        }
      }
      case ASSIGN_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          tableLoader: false,
          assignedCompaniesSaved: true,
          selectionHasChanged: false,
        }
      case ASSIGN_REQUEST_ASYNC.ERROR:
        return { ...state, tableLoader: false }
      case COMPANIES_DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case ASSIGN_REQUEST_ASYNC.CANCEL:
        return { ...state, tableLoader: false, page: 1 }
      case COMPANIES_DATA_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          page: 1,
          sortProperty: '',
          selectedCompaniesMap: {},
          assignedToOtherMap: {},
          selectAll: false,
          filters: {
            emailIntegrationFilter: [],
            groupSettingsFilter: [],
            assignedFilter: DEFAULT_ASSIGNED_FILTER,
          },
          selectionHasChanged: false,
          assignedCompaniesSaved: false,
        }
      default:
        return state
    }
  }
}
